import * as authApi from '@/api/auth';
import { useRequest } from 'ahooks';
import React, { useEffect, useState } from 'react';
import * as fileApi from '@/api/file'
import BootSpinner from './bootSpinner';

interface UserReadyPlaceHolderProps {
    text?: string;
    size?: 'small' | 'default' | 'large';
    fullScreen?: boolean;
    onUserReady?: () => void;
}

const UserReadyPlaceHolder: React.FC<UserReadyPlaceHolderProps> = ({
    size = 'default',
    fullScreen = false,
    onUserReady
}) => {
    const [userIsReady, setUserIsReady] = useState<boolean>(false);
    const [retryCount, setRetryCount] = useState<number>(0);
    const isExitRef = React.useRef(false);
    const MAX_RETRIES = 15;

    const { run: queryReadyState } = useRequest(authApi.userIsReady, {
        manual: true,
        onSuccess: async(res) => {
            if (res?.ok && res?.data?.isReady) {
                localStorage.setItem("isReady", "true");
                setUserIsReady(true);
                if (onUserReady) onUserReady();
                await fileApi.getDemoIntialization()
                // 设置标记表示这是系统初始化刷新，不需要确认提示
                sessionStorage.setItem("skipBeforeUnload", "true");
                window.location.reload();
            } else {
                if (retryCount < MAX_RETRIES && !isExitRef.current) {
                    setRetryCount(prevCount => prevCount + 1);
                    setTimeout(() => {
                        queryReadyState();
                    }, 4000);
                } else {
                    console.log('Max retry attempts reached');
                    setUserIsReady(false); // Stop showing loading UI after max retries
                }
            }
        }
    });

    useEffect(() => {
        const isReady = localStorage.getItem("isReady");
        if (isReady !== "true") {
            queryReadyState();
        } else {
            setUserIsReady(true);
            if (onUserReady) onUserReady();
        }

        return () => {
            isExitRef.current = true;
        };
    }, []);

    if (userIsReady) return null;

    return (
        <div className={`
            flex flex-col items-center justify-center
            ${fullScreen ?
                'fixed inset-0 bg-white dark:bg-[#252526] z-50 h-screen w-screen' :
                'p-5'
            }
        `}>
            <BootSpinner size={size} />
        </div>
    );
};

export default UserReadyPlaceHolder;
